import { __rest } from "tslib";
import React from 'react';
import { block } from '../../utils/cn';
import { sp } from '../spacing/spacing';
import './Box.css';
const b = block('box');
/**
 * Basic block to build other components and for standalone usage as a smart block with build in support of most usable css properties and shortcut `spacing` properties.
 * ```tsx
 * <Box width={300} height={200} spacing={{mb: 2}}>
 *      some content
 * </Box>
 * <Box width={300} height={200} >
 *      some content
 * </Box>
 * ```
 */
export const Box = React.forwardRef(function Box(_a, ref) {
    var { as, children, qa, className, width, height, minWidth, minHeight, maxHeight, maxWidth, position, style: outerStyle, spacing, overflow } = _a, props = __rest(_a, ["as", "children", "qa", "className", "width", "height", "minWidth", "minHeight", "maxHeight", "maxWidth", "position", "style", "spacing", "overflow"]);
    const Tag = as || 'div';
    const style = Object.assign({ width,
        height,
        minWidth,
        minHeight,
        maxHeight,
        maxWidth,
        position }, outerStyle);
    return (React.createElement(Tag, Object.assign({}, props, { "data-qa": qa, style: style, ref: ref, className: b({ overflow }, spacing ? sp(spacing, className) : className) }), children));
});
